function formatMoney(cents) {
  const rupees = Math.round(cents / 100);
  return `₹${rupees}`;
}
document.addEventListener("DOMContentLoaded", function () {
    const wrappers = document.querySelectorAll(".promo-slider-wrapper");
  
    wrappers.forEach(wrapper => {
      const inner = wrapper.querySelector(".promo-slider-inner");
      let slides = Array.from(inner.children);
  
      // Ensure there is enough content to cover at least twice the container's width.
      let totalWidth = slides.reduce((sum, slide) => sum + slide.offsetWidth, 0);
      while (totalWidth < wrapper.offsetWidth * 2) {
        slides.forEach(slide => {
          const clone = slide.cloneNode(true);
          inner.appendChild(clone);
        });
        slides = Array.from(inner.children);
        totalWidth = slides.reduce((sum, slide) => sum + slide.offsetWidth, 0);
      }
  
      // Position each slide based on cumulative width.
      let x = 0;
      slides.forEach(slide => {
        slide.style.position = "absolute";
        slide.style.left = `${x}px`;
        // Save the x position in a data attribute for easy access.
        slide.dataset.x = x;
        x += slide.offsetWidth;
      });
  
      const speed = 1; // Adjust this value for faster/slower scrolling.
  
      function scroll() {
        slides.forEach(slide => {
          let currentX = parseFloat(slide.dataset.x);
          currentX -= speed;
          slide.dataset.x = currentX;
          slide.style.left = `${currentX}px`;
        });
  
        // Check if the first slide has completely scrolled off-screen.
        let firstSlide = slides[0];
        if (parseFloat(firstSlide.dataset.x) + firstSlide.offsetWidth <= 0) {
          // Remove the first slide from the array.
          slides.shift();
  
          // Find the rightmost slide's position.
          let lastSlide = slides[slides.length - 1];
          let newX = parseFloat(lastSlide.dataset.x) + lastSlide.offsetWidth;
  
          // Reposition the off-screen slide to the end.
          firstSlide.dataset.x = newX;
          firstSlide.style.left = `${newX}px`;
  
          // Append it back to our slides array.
          slides.push(firstSlide);
        }
  
        requestAnimationFrame(scroll);
      }
  
      scroll(); // Start the animation loop.
    });
    let footer_headings = [...document.querySelectorAll(".footer-block__heading")];
    footer_headings.forEach(function(footer_heading){
      footer_heading.addEventListener("click",function(){
        footer_heading.classList.toggle("active")
      })
    })
    document.addEventListener("click", function(event) {
      // Open/close toggle for the cart footer opener
      if (event.target.closest(".cart-drawer__footer")) {
          document.querySelector(".cart-drawer-footer-x").classList.toggle("show");
      }
  
      // Close button inside cart details
      if (event.target.closest(".cart-detail__close")) {
          document.querySelector(".cart-drawer-footer-x").classList.remove("show");
      }
  });
  let video_btns = [...document.querySelectorAll("a.c-btn.video-btn")];
  video_btns.forEach(video_btn => {
    video_btn.addEventListener("click",function(e){
      e.preventDefault();
      document.querySelector(".popup-form.contact").classList.add("show")
    })
  });
  document.querySelector(".popup-form.contact .drawer__close").addEventListener("click",function(){
    document.querySelector(".popup-form.contact").classList.remove("show")
  })
  });
  

window.renderCartUpsell= () =>{
    const container = document.querySelector('.cart--recommendation');
    if (!container) return;
  
    container.innerHTML = '';
  
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        if (!cart.items || cart.items.length === 0) return;
  
        const cartProductIds = cart.items.map(i => i.product_id);
  
        // Last 4 unique cart products (latest first)
        const sources = cart.items
          .map(i => i.product_id)
          .reverse()
          .filter((id, index, arr) => arr.indexOf(id) === index)
          .slice(0, 4);
  
        container.insertAdjacentHTML('beforeend', `
          <div class="cart-ai-upsell">
            <div class="recommendation--title">
              <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#6E58C5" viewBox="0 0 256 256"><path d="M229.12,142.65a22.43,22.43,0,0,0-19.55-3.88l-4.32,1C227,119.55,238,99.51,238,80c0-25.36-20.39-46-45.46-46A45.51,45.51,0,0,0,156,52a45.51,45.51,0,0,0-36.54-18C94.39,34,74,54.64,74,80c0,11.38,3.63,22.49,11.29,34.36a29.73,29.73,0,0,0-16.56,8.43L45.52,146H16A14,14,0,0,0,2,160v40a14,14,0,0,0,14,14H120a6,6,0,0,0,1.46-.18l64-16a7.16,7.16,0,0,0,.89-.3L225.17,181l.33-.15a22.6,22.6,0,0,0,3.62-38.18ZM119.46,46a33.16,33.16,0,0,1,31,20.28,6,6,0,0,0,11.1,0,33.16,33.16,0,0,1,31-20.28C210.68,46,226,61.57,226,80c0,20.24-16.18,43-46.8,65.75l-14.87,3.42A26,26,0,0,0,140,114H99.67C90.36,101.67,86,90.81,86,80,86,61.57,101.32,46,119.46,46ZM14,200V160a2,2,0,0,1,2-2H42v44H16A2,2,0,0,1,14,200Zm206.28-30-38.2,16.27L119.26,202H54V154.49l23.21-23.22A17.88,17.88,0,0,1,89.94,126H140a14,14,0,0,1,0,28H112a6,6,0,0,0,0,12h32a6,6,0,0,0,1.34-.15l67-15.41.24-.06A10.6,10.6,0,0,1,220.28,170Z"></path></svg>
              </div>
              <div class="text">Handpicked for you</div>
            </div>
            <div class="cart-ai-grid">
            <div class="swiper-wrapper">
            </div>
            </div>
          </div>
        `);
  
        const grid = container.querySelector('.swiper-wrapper');
  
        // Decide distribution
        let limits = [];
        if (sources.length === 1) limits = [4];
        else if (sources.length === 2) limits = [2, 2];
        else if (sources.length === 3) limits = [2, 1, 1];
        else limits = [1, 1, 1, 1];
  
        const recommended = new Map();
        const calls = [];
  
        sources.forEach((productId, index) => {
          calls.push(
            fetch(
              `${Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=${limits[index]}&intent=related`
            )
              .then(res => res.json())
              .then(data => {
                if (!data.products) return;
  
                data.products.forEach(product => {
                  if (recommended.size >= 4) return;
                  if (cartProductIds.includes(product.id)) return;
                  if (recommended.has(product.id)) return;
  
                  recommended.set(product.id, product);
                });
              })
          );
        });
  
        Promise.all(calls).then(() => {
          recommended.forEach(product => {
            grid.insertAdjacentHTML('beforeend', `
              <div class="swiper-slide">
              <div class="cart-ai-item">
                <a href="${product.url}">
                  <img src="${product.featured_image}" alt="${product.title}">
                </a>
                <div>
                  <a href="${product.url}">
                    <p class="cart-ai-name">${product.title}</p>
                    <p class="cart-ai-price">${formatMoney(product.price)}</p>
                  </a>
                 <product-form data-section-id="cart-ai-upsell">
  <form
    method="post"
    action="/cart/add"
    class="form"
    enctype="multipart/form-data"
    novalidate
    data-type="add-to-cart-form"
  >
    <input type="hidden" name="form_type" value="product">
    <input type="hidden" name="utf8" value="✓">
    <input
      type="hidden"
      name="id"
      value="${product.variants[0].id}"
      class="product-variant-id"
    >

    <button
      type="submit"
      name="add"
      class="quick-add__submit button button--secondary button--full-width"
      aria-haspopup="dialog"
    >
      <span>Add</span>
      <span class="sold-out-message hidden">Sold out</span>

      <div class="loading__spinner hidden">
        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
          <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
        </svg>
      </div>
    </button>
  </form>
</product-form>
                </div>
              </div>
              </div>
            `);
          });
        });
        window.handpicked_slider();
      });
  }
function offersidebarToggle(){
  let sidebar = document.querySelector(".offer-sidebar")
  if(!sidebar) return;
  let sidebar_opener = document.querySelector("cart-drawer .after.open");
  sidebar_opener.addEventListener("click",function(){
    sidebar.classList.toggle("active")
  })
  let sidebar_closer = document.querySelector("cart-drawer .after.close");
  sidebar_closer.addEventListener("click",function(){
    sidebar.classList.remove("active")
  })
}
window.pdf_slider = () => {
  if(window.innerWidth < 768) return;
  if(!document.querySelector(".pfd-products")) return;
  new Swiper('.pfd-products', {
    slidesPerView: 2.1,
    spaceBetween: 8,
    pagination: {
      clickable: true,
    },
     breakpoints: {
      320: {
        slidesPerView: 1.6,
        spaceBetween: 8,
      },
      768: {
        slidesPerView: 2.1,
        spaceBetween: 8,
      }
    }
  });
}
window.handpicked_slider = () => {
  if(window.innerWidth < 768) return;
  if(!document.querySelector(".cart-ai-grid")) return;
  new Swiper('.cart-ai-grid', {
    slidesPerView: 2.1,
    spaceBetween: 8,
    pagination: {
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1.6,
        spaceBetween: 8,
      },
      768: {
        slidesPerView: 2.1,
        spaceBetween: 8,
      },
    },
  });
}
function attachOffersMainProduct(){
  let offers = document.querySelector(".offer-sidebar .available--offers");
  if(!offers) return;
  let main_wrapper =document.querySelector(".product-main-offers");
  if(!main_wrapper) return;
  main_wrapper.innerHTML = offers.innerHTML;
}
function wishlist(){
  const WISHLIST_KEY = 'shopify_wishlist';
function getWishlist() {
  return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
}

function saveWishlist(list) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
}

function toggleWishlist(handle) {
  let list = getWishlist();

  if (list.includes(handle)) {
    list = list.filter(item => item !== handle);
  } else {
    list.push(handle);
  }

  saveWishlist(list);
}

//Whatsapp




document.addEventListener('click', function (e) {
 
  const btn = e.target.closest('.wishlist-btn');
  if (!btn) return;

  const handle = btn.dataset.productHandle;
  toggleWishlist(handle);
  btn.classList.toggle('active');
   const WISHLIST_KEY = 'shopify_wishlist';
  const wishlist2 = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
  document.querySelector(".header__icon--wishlist").classList.toggle("active", wishlist2.length > 0);
});
}
function notifyMe(){
   if (
    !window.whatsappNotifyConfig ||
    !window.whatsappNotifyConfig.enabled ||
    !window.whatsappNotifyConfig.number
  ) {
    return;
  }

  const whatsappNumber = window.whatsappNotifyConfig.number;
  function isSoldOut(button) {
    return (
      button.getAttribute("sold__out")
    );
  }

  function enhanceSoldOutButtons() {
    document.querySelectorAll("[sold__out]").forEach(button => {

      // if (!isSoldOut(button)) return;
      if (button.dataset.whEnhanced === "true") return;

      button.dataset.whEnhanced = "true";

      button.disabled = false;
      button.removeAttribute("disabled");
      button.style.pointerEvents = "auto";
      
      const visibleSpan = [...button.querySelectorAll("span")]
        .find(span => !span.classList.contains("hidden"));

      if (visibleSpan) visibleSpan.textContent = "Notify me";

      button.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        let productTitle = "this product";

        const titleEl =
          button.closest(".card")?.querySelector("a, h2, h3") ||
          button.closest(".product")?.querySelector("h1");

        if (titleEl) {
          productTitle = titleEl.textContent.trim();
        }

        const message = encodeURIComponent(
          `Hi, I'm interested in the product "${productTitle}" which is currently sold out. Please notify me when it's back in stock.`
        );

        window.open(
          `https://wa.me/${whatsappNumber}?text=${message}`,
          "_blank"
        );
      });
    });
  }

  enhanceSoldOutButtons();

  const observer = new MutationObserver(enhanceSoldOutButtons);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
function renderWishlist(){
  const WISHLIST_KEY = 'shopify_wishlist';
  const wishlistContainer = document.getElementById('wishlist-container');
  
  const wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];;
  document.querySelector(".header__icon--wishlist").classList.toggle("active", wishlist.length > 0);
  if(!wishlistContainer) return;
  if (!wishlist.length) {
    document.querySelector(".wishlist-section .page-width").innerHTML = '<div class="collection__title title-wrapper title-wrapper--no-top-margin "><h2 class="title inline-richtext h1">Wishlist</h2></div><div><p>Your wishlist is empty.</p><a href="/collections/all" class="button">Continue shopping</a></div>';
    return;
  }

  wishlistContainer.innerHTML = '';
  document.querySelector(".wishlist--header").innerHTML += '<div class="collection__title title-wrapper title-wrapper--no-top-margin "><h2 class="title inline-richtext h1">Wishlist</h2></div>';

  wishlist.forEach(handle => {
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        const card = document.createElement('div');
        card.className = 'card-wrapper product-card-wrapper';
        card.innerHTML = `
        <link href="//decorelse.com/cdn/shop/t/37/assets/component-rating.css?v=179577762467860590411767590136" rel="stylesheet" type="text/css" media="all">
  <link href="//decorelse.com/cdn/shop/t/37/assets/component-volume-pricing.css?v=111870094811454961941767590140" rel="stylesheet" type="text/css" media="all">
  <link href="//decorelse.com/cdn/shop/t/37/assets/quick-order-list.css?v=129932180309343703061767590209" rel="stylesheet" type="text/css" media="all">
  <link href="//decorelse.com/cdn/shop/t/37/assets/quantity-popover.css?v=129068967981937647381767590206" rel="stylesheet" type="text/css" media="all">
          <div class="card card--standard card--media" style="--ratio-percent: 125.0%;">
            <div class="card__inner color-scheme-1 gradient ratio" style="--ratio-percent: 125.0%;">
              <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                  <img src="${product.images[0]}" alt="${product.title}" loading="lazy" width="533" height="667">
                </div>
              </div>
              
              <a class="hidden_link" href="/products/${product.handle}"><span class="hidden"></span></a>
              
            </div>
            <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading">
                    <a href="/products/${product.handle}" class="full-unstyled-link">${product.title}</a>
                  </h3>
                  <div class="card-information">
                    <div class="price">
                      <div class="price__container">
                        <div class="price__regular">
                          <span class="visually-hidden">Regular price</span>
                          <span class="price-item price-item--regular">${formatMoney(product.price)}</span>
                        </div>
                        <div class="tax-inc">Price Incl. of all Taxes</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card__badge top left"></div>
              </div>
              <div class="quick-addx no-js-hidden">
                <product-form data-section-id="wishlist">
                  <form method="post" action="/cart/add" class="form" enctype="multipart/form-data" novalidate data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${product.variants[0].id}" class="product-variant-id">
                    <button type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog">
                      <span>Add to bag</span>
                      <span class="sold-out-message hidden">Sold out</span>
                      <div class="loading__spinner hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                          <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
                        </svg>
                      </div>
                    </button>
                  </form>
                </product-form>
              </div>
          </div>
        `;
        wishlistContainer.appendChild(card);
      });
  });
}
function stickyaddtocart(){
  const addToCartBtn = document.querySelector('.sticky-cart');
  if(!addToCartBtn) return;
  window.addEventListener('scroll', function(){
    if(window.scrollY > 100){
      addToCartBtn.classList.add('show');
    }else{
      addToCartBtn.classList.remove('show');
    }
  })
}
function initWishlistButtons() {
  const WISHLIST_KEY = 'shopify_wishlist';
  const wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];

  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    const handle = btn.dataset.productHandle;
    if (wishlist.includes(handle)) {
      btn.classList.add('active');
    }
  });
}
document.addEventListener('DOMContentLoaded', function(){
  renderCartUpsell();
  offersidebarToggle();
  // attachOffersMainProduct();
  // wishlist();
  // renderWishlist();
  stickyaddtocart();
  initWishlistButtons();
  notifyMe();
});
